import { z } from "zod";
import {
  DOCUMENT_NO,
  HIDE_ZERO_BALANCES,
  INCLUDE_PERIOD_0,
  SHOW_LONG_DESCRIPTION,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_NO]: z.string().trim().min(1, "Document No is required"),
  [INCLUDE_PERIOD_0]: z.boolean().optional(),
  [HIDE_ZERO_BALANCES]: z.boolean().optional(),
  [SHOW_LONG_DESCRIPTION]: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;
